import React from 'react';
import * as Sentry from '@sentry/react';
import {Alert, AlertTitle, Container, Link} from '@mui/material';

export function PageErrorMessage() {
    return <Container maxWidth="sm" sx={{py: 3}}>
        <Alert severity="error">
            <AlertTitle>Something went wrong</AlertTitle>
            Please refresh the page, or contact support at <Link href="mailto:support@fcfiling.com">support@fcfiling.com</Link> if this keeps happening.
        </Alert>
    </Container>;
}

/** Shows a friendly message, and reports the error, instead of leaving a blank page when the content fails to render. */
export function PageErrorBoundary({children}: {children: React.ReactNode}) {
    return <Sentry.ErrorBoundary fallback={<PageErrorMessage/>}>{children}</Sentry.ErrorBoundary>;
}
